import { EProfileFields } from '../constants';

export const attributesFields = [
	{
		fieldName: EProfileFields.indicativeAcceptablePricing,
		fieldTitle: 'Pricing',
		prefix: '£',
	},
	{
		fieldTitle: 'Max Operators',
		fieldName: EProfileFields.maxOperators,
	},
	{
		fieldTitle: 'Height',
		fieldName: EProfileFields.height,
	},
	{
		fieldTitle: 'Responsible',
		fieldName: [EProfileFields.responsible, EProfileFields.title],
	},
	{
		fieldTitle: 'UPRN',
		fieldName: EProfileFields.uprn,
	},
];

export const locationFields = [
	{
		fieldName: EProfileFields.ngr,
		fieldTitle: 'NGR',
	},
	{
		fieldName: EProfileFields.lat,
		fieldTitle: 'Latitude',
	},
	{
		fieldName: EProfileFields.lng,
		fieldTitle: 'Longitude',
	},
	{
		fieldName: EProfileFields.northing,
		fieldTitle: 'Northing',
	},
	{
		fieldName: EProfileFields.easting,
		fieldTitle: 'Easting',
	},
];
